import { INavigationBehaviour, NavigationAwareObject } from "./NavigationAwareObject";
import { RenderObject } from "./RenderObject";
import { vec3 } from "gl-matrix";

export class EntityMovementBehaviour implements INavigationBehaviour {

    constructor(public entity: RenderObject) {

    }

    attach(navObject: NavigationAwareObject) {

        navObject.movement.onStep.subscribe(step => {
            let dir = vec3.subtract(vec3.create(), step.newPosition, step.oldPosition);
            this.entity.rotateTo(dir);
            if (this.entity.animationState) {
                this.entity.animationState.switchState('Walk');
            }
        });

        navObject.movement.onComplete.subscribe(mv => {
            if (this.entity.animationState) {
                this.entity.animationState.switchState('Idle');
            }
        });
    }

    detach(navObject: NavigationAwareObject) {
    }
}